import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import HeroPresenter from "presenters/HeroPresenter";
import CategoryCollectionPresenter from "presenters/CategoryCollectionPresenter";
import CategoryHeroPresenter from "presenters/CategoryHeroPresenter";
import SeoPresenter from "presenters/SeoPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    query: PropTypes.string,
    title: PropTypes.string,
    metaDescription: PropTypes.string,
    metaKeywords: PropTypes.string,
    indexable: PropTypes.bool,
    pageModules: PropTypes.arrayOf(
      PropTypes.oneOfType([
        AlgoliaCardsPresenter.shape(),
        HeroPresenter.shape(),
        CategoryCollectionPresenter.shape(),
        CategoryHeroPresenter.shape(),
      ]),
    ),
    footer: PropTypes.shape({}),
    seo: SeoPresenter.shape({}),
  },
  {
    seoTitle(page) {
      if (!page) return "";

      return this.seo(page)?.title || this.title(page) || "";
    },
    seoDescription(page) {
      if (!page) return "";

      return this.seo(page)?.description || this.metaDescription(page) || "";
    },
    context(page) {
      if (!page) return "";

      switch (this.id(page)) {
        case "invites":
          return "invites";
        case "starring-you-ai":
          return "syai";
        default:
          return "category";
      }
    },
  },
);
